exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.actionIcons .icon[data-v-107d6a56] {\n    color: red;\n    cursor: pointer;\n}\n\n", ""]);

// exports
